import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cfcb3fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-lang" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_caret_down_outlined = _resolveComponent("caret-down-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, {
    trigger: ['click'],
    placement: "bottomCenter"
  }, {
    overlay: _withCtx(() => [
      _createVNode(_component_a_menu, { class: "men-scroll" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pamirsPartnerList, (opt) => {
            return (_openBlock(), _createBlock(_component_a_menu_item, {
              key: opt,
              onClick: ($event: any) => (_ctx.onLangChange(opt))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opt.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.pamirsPartner.name), 1),
        _createVNode(_component_caret_down_outlined, { style: { fontSize: '12px', color: '#c3c4c6' } })
      ])
    ]),
    _: 1
  }))
}